import { render, staticRenderFns } from "./AssetsTopNav.vue?vue&type=template&id=5a6fee04&scoped=true"
import script from "./AssetsTopNav.vue?vue&type=script&lang=js"
export * from "./AssetsTopNav.vue?vue&type=script&lang=js"
import style0 from "./AssetsTopNav.vue?vue&type=style&index=0&id=5a6fee04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6fee04",
  null
  
)

export default component.exports